import { useMutation } from "@tanstack/react-query";
import {
  UpdateUserStatusBody,
  updateUserStatus,
} from "../../../services/accountService";

export default function useUpdateUserStatusMutation() {
  return useMutation<string, string, UpdateUserStatusBody>((body) =>
    updateUserStatus(body)
  );
}
